"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyEventInvitationToHuntingDistrict = exports.DependencyEventInvitationToEvent = exports.DependencyEventInvitationToPerson = exports.EventTransaction = exports.EventInvitation = exports.Notes = exports.NoteFlag = exports.EventInvitationChartColorMapping = exports.EventInvitationStatus = exports.EventInvitationStatusesList = void 0;
const moment = require("moment");
const obejct_diff_1 = require("../utils/obejct-diff");
const network_constants_1 = require("./network.constants");
exports.EventInvitationStatusesList = [
    "assigned",
    "approved",
    "pending",
    "pending_viewed",
    "cancled",
    "accepted",
    "declined",
    "expired"
];
var EventInvitationStatus;
(function (EventInvitationStatus) {
    EventInvitationStatus["ASSIGNED"] = "assigned";
    EventInvitationStatus["APPROVED"] = "approved";
    EventInvitationStatus["PENDING"] = "pending";
    EventInvitationStatus["PENDING_VIEWED"] = "pending_viewed";
    EventInvitationStatus["CANCLED"] = "cancled";
    EventInvitationStatus["ACCEPTED"] = "accepted";
    EventInvitationStatus["DECLINED"] = "declined";
    EventInvitationStatus["EXPIRED"] = "expired"; // invitation expired 
})(EventInvitationStatus || (exports.EventInvitationStatus = EventInvitationStatus = {}));
exports.EventInvitationChartColorMapping = new Map([
    [`${EventInvitationStatus.ASSIGNED}`, 'rgba(0,0,0,.1)'],
    [`${EventInvitationStatus.DECLINED}`, '#f97762'],
    [`${EventInvitationStatus.ACCEPTED}`, '#b8e886'],
    [`${EventInvitationStatus.PENDING}`, '#fbb465'],
    [`${EventInvitationStatus.PENDING_VIEWED}`, '#fbd365'],
    [`${EventInvitationStatus.EXPIRED}`, '#c277a6'],
    [`${EventInvitationStatus.APPROVED}`, '#9eddcc'],
    [`${EventInvitationStatus.CANCLED}`, 'rgba(0,0,0,.2)'],
]);
var NoteFlag;
(function (NoteFlag) {
    NoteFlag["IMPORTANT"] = "important";
    NoteFlag["INFO"] = "info";
    NoteFlag["NONE"] = "none";
})(NoteFlag || (exports.NoteFlag = NoteFlag = {}));
class Notes {
    constructor(timeStamp, text, flag) {
        this.timeStamp = timeStamp;
        this.text = text;
        this.flag = NoteFlag.NONE;
        if (flag)
            this.flag = flag;
    }
}
exports.Notes = Notes;
class EventInvitation {
    constructor() {
        this.identifier = undefined;
        this.contextId = undefined;
        this.eventUpdateTimestamp = undefined;
        this.personAnrede = undefined;
        this.personTitelAkademisch = undefined;
        this.personTitelAndere = undefined;
        this.personVorname = undefined;
        this.personNachname = undefined;
        this.personAnzeigeName = undefined;
        this.personGeschlecht = undefined;
        this.personTelefon = undefined;
        this.personEmailAddresse = undefined;
        this.personLegalPersonalAddress = undefined;
        this.personBillingAddress = undefined;
        this.creationDate = undefined;
        this.updateTimestamp = undefined;
    }
    searchFilter(filter) {
        const str = `${this.personAnzeigeName}${this.personVorname}${this.personNachname}${this.personEmailAddresse}${this.huntingDistrictName}${this.eventName}`.toLowerCase();
        return str.includes(filter);
    }
    setProcessingStatus(status) {
        const now = new Date();
        const prevStatus = this.processingStatus;
        switch (status) {
            case (EventInvitationStatus.PENDING): {
                this.invitationSend = now;
                break;
            }
            case (EventInvitationStatus.APPROVED): {
                this.invitationApproved = now;
                break;
            }
            case (EventInvitationStatus.ACCEPTED): {
                this.invitationAccepted = now;
                break;
            }
            case (EventInvitationStatus.CANCLED): {
                break;
            }
            case (EventInvitationStatus.DECLINED): {
                this.invitationDeclined = now;
                break;
            }
            case (EventInvitationStatus.EXPIRED): {
                break;
            }
        }
        this.processingStatus = status;
    }
    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key
     */
    replacerFn(key) {
        // if (key == "context" || key == "outlines") return false
        // else 
        return true;
    }
    static valid(event, person) {
        const { date, name, huntingDistrictId, huntingDistrictName } = event;
        const { vorname, nachname, anzeigeName, invitationRef } = person;
        return name
            // && huntingDistrictId 
            //&& huntingDistrictName 
            && moment().isBefore(moment(date))
            // && ((vorname && nachname) || anzeigeName))
            && invitationRef;
    }
}
exports.EventInvitation = EventInvitation;
EventInvitation.builder = {
    newEventIvitation(event, person) {
        if (!EventInvitation.valid(event, person))
            throw new Error(`Not enough data...`);
        const invite = new EventInvitation();
        invite.contextId = event.contextId;
        const { date, name, huntingDistrictId, huntingDistrictName } = event;
        invite.eventId = event.identifier;
        invite.eventName = name;
        invite.eventDate = date;
        invite.eventUpdateTimestamp = event.updateTimestamp;
        invite.huntingDistrictId = huntingDistrictId;
        invite.huntingDistrictName = huntingDistrictName;
        invite.processingStatus = EventInvitationStatus.ASSIGNED;
        const { emailAddresse, vorname, nachname, telefon, anzeigeName, geschlecht, legalPersonalAddress, billingAddress, anrede, titelAkademisch, titelAndere, identifier, invitationRef } = person;
        invite.personId = identifier;
        invite.personAnrede = anrede;
        invite.personAnzeigeName = anzeigeName;
        invite.personBillingAddress = billingAddress;
        invite.personEmailAddresse = emailAddresse;
        invite.personVorname = vorname;
        invite.personNachname = nachname;
        invite.personUpdateTimestamp = person.updateTimestamp;
        invite.personGeschlecht = geschlecht;
        invite.personTelefon = telefon;
        invite.personLegalPersonalAddress = legalPersonalAddress;
        invite.personTitelAkademisch = titelAkademisch;
        invite.personTitelAndere = titelAndere;
        invite.personInvitationRef = invitationRef;
        return invite;
    },
    fromAny(element) {
        const { creationDate, updateTimestamp, invitationSend, invitationViewed, invitationExpiration, eventDate, invitationAccepted, invitationDeclined, eventUpdateTimestamp, personUpdateTimestamp, invitationApproved, personDeleted, siteReferralURL } = element;
        const invite = new EventInvitation();
        Object.assign(invite, element);
        invite.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : invite.creationDate;
        invite.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : invite.updateTimestamp;
        invite.invitationSend = invitationSend ? (0, obejct_diff_1.isDate)(invitationSend) ? invitationSend : (0, obejct_diff_1.firestoreTimestampToDate)(invitationSend) : invite.invitationSend;
        invite.invitationViewed = invitationViewed ? (0, obejct_diff_1.isDate)(invitationViewed) ? invitationViewed : (0, obejct_diff_1.firestoreTimestampToDate)(invitationViewed) : invite.invitationViewed;
        invite.invitationExpiration = invitationExpiration ? (0, obejct_diff_1.isDate)(invitationExpiration) ? invitationExpiration : (0, obejct_diff_1.firestoreTimestampToDate)(invitationExpiration) : invite.invitationExpiration;
        invite.invitationAccepted = invitationAccepted ? (0, obejct_diff_1.isDate)(invitationAccepted) ? invitationAccepted : (0, obejct_diff_1.firestoreTimestampToDate)(invitationAccepted) : invite.invitationAccepted;
        invite.invitationDeclined = invitationDeclined ? (0, obejct_diff_1.isDate)(invitationDeclined) ? invitationDeclined : (0, obejct_diff_1.firestoreTimestampToDate)(invitationDeclined) : invite.invitationDeclined;
        invite.eventUpdateTimestamp = eventUpdateTimestamp ? (0, obejct_diff_1.isDate)(eventUpdateTimestamp) ? eventUpdateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(eventUpdateTimestamp) : invite.eventUpdateTimestamp;
        invite.personUpdateTimestamp = personUpdateTimestamp ? (0, obejct_diff_1.isDate)(personUpdateTimestamp) ? personUpdateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(personUpdateTimestamp) : invite.personUpdateTimestamp;
        invite.eventDate = eventDate ? (0, obejct_diff_1.isDate)(eventDate) ? eventDate : (0, obejct_diff_1.firestoreTimestampToDate)(eventDate) : invite.eventDate;
        invite.invitationApproved = invitationApproved ? (0, obejct_diff_1.isDate)(invitationApproved) ? invitationApproved : (0, obejct_diff_1.firestoreTimestampToDate)(invitationApproved) : invite.invitationApproved;
        invite.personDeleted = personDeleted ? (0, obejct_diff_1.isDate)(personDeleted) ? personDeleted : (0, obejct_diff_1.firestoreTimestampToDate)(personDeleted) : invite.personDeleted;
        invite.siteReferralURL = siteReferralURL ? siteReferralURL : invite.siteReferralURL;
        return invite;
    }
};
class EventTransaction {
    constructor() { }
    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key
     */
    replacerFn(key) {
        if (key == "updateOperations")
            return false;
        else
            return true;
    }
}
exports.EventTransaction = EventTransaction;
EventTransaction.builder = {
    createUpdate(oldEventInvitation, newEventInvitation, additionalInformation) {
        const { contextId, eventId } = newEventInvitation;
        if (!contextId || !eventId)
            throw new Error(`Invalid data, no context or eventId`);
        const updates = (0, obejct_diff_1.diffObject)(oldEventInvitation, newEventInvitation, {});
        let transactions = [];
        for (let [key, val] of Object.entries(updates)) {
            let value = val;
            if ((0, obejct_diff_1.isObject)(value)) {
                const operationType = (value['oldValue'] && value['newValue']) ? 'update'
                    : (!value['oldValue'] && value['newValue']) ? 'create'
                        : (value['oldValue'] && !value['newValue']) ? 'delete' : undefined;
                if (!operationType)
                    throw new Error(`Invalid operation Type!`);
                transactions.push({
                    fieldName: key,
                    oldValue: value['oldValue'],
                    newValue: value['newValue'],
                    operation: operationType
                });
            }
        }
        const eventTransaction = new EventTransaction();
        eventTransaction.eventInvitationId = oldEventInvitation.identifier;
        eventTransaction.contextId = contextId;
        eventTransaction.transactions = transactions;
        eventTransaction.updateOperations = (0, obejct_diff_1.updatesToFirestoreUpdates)(updates);
        eventTransaction.creationDate = new Date();
        if (additionalInformation)
            Object.assign(eventTransaction, additionalInformation);
        return eventTransaction;
    },
    createFromNewInvitation(invitation, additionalInformation) {
        const eventTransaction = new EventTransaction();
        Object.assign(eventTransaction, {
            contextId: invitation.contextId,
            userDisplayName: additionalInformation === null || additionalInformation === void 0 ? void 0 : additionalInformation.userDisplayName,
            userId: additionalInformation === null || additionalInformation === void 0 ? void 0 : additionalInformation.userId,
            deviceName: additionalInformation === null || additionalInformation === void 0 ? void 0 : additionalInformation.deviceName,
            eventInvitationId: invitation.identifier,
            creationDate: new Date(),
            transactions: [
                {
                    operation: 'create',
                    referenceId: invitation.identifier
                }
            ]
        });
        return eventTransaction;
    },
    setFromAny(element) {
        const { creationDate } = element;
        const eventTransaction = new EventTransaction();
        Object.assign(eventTransaction, element);
        // dates... 
        eventTransaction.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : eventTransaction.creationDate;
        return eventTransaction;
    }
};
exports.DependencyEventInvitationToPerson = {
    collectionName: network_constants_1.NetworkConstants.COLLECTION_PERSON,
    mapping: new Map([
        ["personEmailAddresse", "emailAddresse"],
        ["personNachname", "nachname"],
        ["personVorname", "vorname"],
        ["personAnzeigeName", "anzeigeName"],
        ["personGeschlecht", "geschlecht"],
        ["personAnrede", "anrede"],
        ["personTitelAkademisch", "titelAkademisch"],
        ["personTitelAndere", "titelAndere"],
        ["personTelefon", "telefon"],
        ["personLegalPersonalAddress.zip", "legalPersonalAddress.zip"],
        ["personLegalPersonalAddress.address1", "legalPersonalAddress.address1"],
        ["personLegalPersonalAddress.address2", "legalPersonalAddress.address2",],
        ["personLegalPersonalAddress.city", "legalPersonalAddress.city"],
        ["personLegalPersonalAddress.county", "legalPersonalAddress.county"],
        ["personLegalPersonalAddress.country", "legalPersonalAddress.country"],
        ["personBillingAddress.zip", "billingAddress.zip"],
        ["personBillingAddress.address1", "billingAddress.address1"],
        ["personBillingAddress.address2", "billingAddress.address2"],
        ["personBillingAddress.city", "billingAddress.city"],
        ["personBillingAddress.county", "billingAddress.county"],
        ["personBillingAddress.country", "billingAddress.country"],
    ]),
    mappingIdentifier: "personId",
    getDoc: (firestore, identifier) => {
        return firestore.collection(network_constants_1.NetworkConstants.COLLECTION_PERSON)
            .doc(identifier);
    },
    getQuery: (firestore, origin, now) => {
        return null;
    }
};
exports.DependencyEventInvitationToEvent = {
    collectionName: network_constants_1.NetworkConstants.COLLECTION_EVENT,
    mapping: new Map([
        ["eventName", "name"],
        ["eventDate", "date"],
        ["huntingDistrictId", "huntingDistrictId"],
        ["huntingDistrictName", "huntingDistrictName"]
    ]),
    mappingIdentifier: "eventId",
    getDoc: (firestore, identifier) => {
        return firestore.collection(network_constants_1.NetworkConstants.COLLECTION_EVENT)
            .doc(identifier);
    },
    getQuery: (firestore, origin, now) => {
        return null;
    }
};
exports.DependencyEventInvitationToHuntingDistrict = {
    collectionName: network_constants_1.NetworkConstants.COLLECTION_HUNTING_DISTRICT,
    mapping: new Map([
        ["huntingDistrictName", "name"]
    ]),
    mappingIdentifier: "huntingDistrictId",
    getDoc: (firestore, identifier) => {
        return firestore.collection(network_constants_1.NetworkConstants.COLLECTION_HUNTING_DISTRICT)
            .doc(identifier);
    },
    getQuery: (firestore, origin, now) => {
        return null;
    }
};
